import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { OurValuesInner } from './OurValuesInner/OurValuesInner';

import { JSX } from 'react';
import styles from './styles.module.scss';

export type OurValuesProps = SliceComponentProps<Content.OurValuesSlice>;

const OurValues = ({ slice }: OurValuesProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.box_container}>
        <OurValuesInner data={slice.primary} />
      </BoxContainer>
    </section>
  );
};

export default OurValues;
